import useBodyClass from '@components/Hooks/useBodyClass';
import Termite from '@divtel/termite';
import Fader from '@Shared/Fader';
import React from 'react';
import { Container as Grid } from 'react-bootstrap';
import ContactAdminError from './Error';
import ContactAdminForm from './Form';
import ContactAdminSuccess from './Success';


const ContactAdmin: React.FC = () => {

  useBodyClass(['contact-admin-page']);

  return (
    // @ts-ignore
    <Termite app='Contact My Administrator' noSession>
      <div className='main-section'>
        <Fader>
          <Grid style={{ paddingTop: 44 }}>
            <ContactAdminError />
            <ContactAdminSuccess />
            <ContactAdminForm />
          </Grid>
        </Fader>
      </div>
    </Termite>
  );
}

export default ContactAdmin;